<template>
    <div class="childbanner" :style='{backgroundImage:"url("+childbannerData.childbanner+")"}'>
        <div class="caption-box">
            <h1 class="cpation" :class='{isShows:isShow}'>{{childbannerData.caption}}</h1>
        </div>
        <h5 class="title">{{childbannerData.title}}</h5>
    </div>
</template>
<script>
    export default {
        name: 'ChildBanner',
        props: {
            childbannerData: Object
        },
        data() {
            return {
                isShow: false
            }
        },
        methods: {
            changeShow() {
                this.isShow = true
            }
        }
    }
</script>
<style scoped>
    .childbanner {
        height: 996px;
        background: #000000 no-repeat center;
        background-attachment: fixed;
        background-size: cover;
        position: relative;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: flex-start;
        padding-left: 140px;
    }

    .childbanner::after {
        position: absolute;
        content: '';
        display: block;
        width: 100%;
        height: 100%;
        top: 0;
        left: 0;
        background-color: #000000;
        opacity: 0.32;
    }

    .caption-box {
        overflow: hidden;
    }

    .cpation {
        position: relative;
        top: 100%;
        font-size: 98px;
        font-weight: bold;
        line-height: 119px;
        color: rgba(255, 255, 255, 1);
        text-transform: uppercase;
        max-width: 564px;
        z-index: 3;
        transition: all 0.45s ease-in-out;
    }

    .isShows {
        top: 0%
    }

    .title {
        position: relative;
        font-size: 16px;
        font-weight: 400;
        line-height: 22px;
        color: rgba(255, 255, 255, 1);
        margin-top: 6px;
        z-index: 3;
    }

    @media(max-width: 995px) {
        .childbanner {
            height: 100vh;
            padding-left: 0px;
            justify-content: center;
            align-items: center;
            background-attachment: initial;
        }

        .cpation {
            font-size: 35px;
        }

        .title {
            font-size: 24px;
        }
    }

    /* @media(max-width: 1023px){
        .childbanner{
            height: 1500px;
            background-attachment: initial;
        }
        .title {
        font-size: 50px;
        line-height: 120%;
        margin-top: 3%;
    }
    } */
</style>


// WEBPACK FOOTER //
// src/components/base/childbanner.vue